import * as React from 'react';
import { AlternativeCalculationDialog } from '../alternative-calculation';
import { ManipulationTariffPercentResponse, TariffPercentResponse } from '../../interfaces/Case';

const AlternativeCalculationPage: React.FC = () => {
  const [open, setOpen] = React.useState(true);
  const close = () => setOpen(false);

  return open ? (
    <AlternativeCalculationDialog
      onClose={close}
      calculationHistoryId={0}
      stepFormId={0}
      orderList={[]}
      caseInfo={null}
      closeDialog={close}
      manipulationTariff={{ id: 0, value: 0 } as ManipulationTariffPercentResponse}
      insurerList={[]}
      serviceId={null}
      additionTariff={{ id: 0, value: 0 } as TariffPercentResponse}
      discountTariff={{ id: 0, value: 0 } as TariffPercentResponse}
      packageCalculationId={null}
      alternativePartVariantsEnabled={true}
      isOffline={false}
    />
  ) : null;
};

export default AlternativeCalculationPage;
